var map = {
	"./cloud.svg": "raFq",
	"./controllable.svg": "bN2E",
	"./cost.svg": "PTF2",
	"./customizable.svg": "NOyy",
	"./maintanable.svg": "AvOQ",
	"./scalable.svg": "GcIx",
	"./time.svg": "IARW"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Krg0";